<template>
  <div>
    <div id="container">
      <div id="address">
        <h3>Contact</h3>
        <p>Techno Plaza, Kannadikadu, Maradu. P. O.,</p>
        <p>Ernakulam, Kerala – 682 304</p>
        <p>Tele: +91 484 40 222 46, +91 484 40 222 47</p>
        <p>E-mail: office@mathskit.org</p>
        <p>
          Website: www.mathskit.org
        </p>
      </div>
      <div id="form">
        <h3>Kit Delivery Form</h3>
        <h5>Contact Information</h5>
        <div class="formSection">
          <div class="formElement">
            <label for="">Name of the School</label
            ><input type="text" name="" id="" />
          </div>
          <div class="formElement">
            <label for="">Name of the Principal/Manager</label
            ><input type="text" name="" id="" />
          </div>
          <div class="formElement">
            <label for="">Address</label><textarea name="" id=""></textarea>
          </div>
          <div class="formElement">
            <label for="">Tele</label><input type="text" name="" id="" />
          </div>
          <div class="formElement">
            <label for="">Mob</label><input type="text" name="" id="" />
          </div>
          <div class="formElement">
            <label for="">Email</label><input type="text" name="" id="" />
          </div>
          <div class="formElement">
            <label for="">Syllabus</label><input type="text" name="" id="" />
          </div>
        </div>

        <h5>Number Of Students - Classwise Distribution</h5>
        <div class="formSection">
          <div class="formElement">
            <label for="">STD 01</label><input type="text" name="" id="n-1" />
          </div>
          <div class="formElement">
            <label for="">STD 02</label><input type="text" name="" id="n-2" />
          </div>
          <div class="formElement">
            <label for="">STD 03</label><input type="text" name="" id="n-3" />
          </div>
          <div class="formElement">
            <label for="">STD 04</label><input type="text" name="" id="n-4" />
          </div>
          <div class="formElement">
            <label for="">STD 05</label><input type="text" name="" id="n-5" />
          </div>
          <div class="formElement">
            <label for="">STD 06</label><input type="text" name="" id="n-6" />
          </div>
          <div class="formElement">
            <label for="">STD 07</label><input type="text" name="" id="n-7" />
          </div>
          <div class="formElement">
            <label for="">STD 08</label><input type="text" name="" id="n-8" />
          </div>
          <div class="formElement">
            <label for="">STD 09</label><input type="text" name="" id="n-9" />
          </div>
          <div class="formElement">
            <label for="">STD 10</label><input type="text" name="" id="n-10" />
          </div>
          <div class="formElement">
            <label for="">Total Students</label
            ><input type="text" name="" id="n-t" />
          </div>
        </div>
        <h5>Number Of Kits Delivered - Classwise Distribution</h5>
        <div class="formSection">
          <div class="formElement">
            <label for="">STD 01</label><input type="text" name="" id="k-1" />
          </div>
          <div class="formElement">
            <label for="">STD 02</label><input type="text" name="" id="k-2" />
          </div>
          <div class="formElement">
            <label for="">STD 03</label><input type="text" name="" id="k-3" />
          </div>
          <div class="formElement">
            <label for="">STD 04</label><input type="text" name="" id="k-4" />
          </div>
          <div class="formElement">
            <label for="">STD 05</label><input type="text" name="" id="k-5" />
          </div>
          <div class="formElement">
            <label for="">STD 06</label><input type="text" name="" id="k-6" />
          </div>
          <div class="formElement">
            <label for="">STD 07</label><input type="text" name="" id="k-7" />
          </div>
          <div class="formElement">
            <label for="">STD 08</label><input type="text" name="" id="k-8" />
          </div>
          <div class="formElement">
            <label for="">STD 09</label><input type="text" name="" id="k-9" />
          </div>
          <div class="formElement">
            <label for="">STD 10</label><input type="text" name="" id="k-10" />
          </div>
          <div class="formElement">
            <label for="">Total Kits</label
            ><input type="text" name="" id="k-t" />
          </div>
        </div>
        <button>Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact",
  data() {
    return {
      formElement: {
        "Contact Details": ["", "", "", "", "", ""]
      }
    };
  }
};
</script>

<style lang="scss" scoped>
#container {
  display: flex;
  flex-direction: column;
  #address,
  #form {
    width: 100%;
    display: flex;
    flex-direction: column;
     h3 {
      color: $color1;
      font-weight: 400;
    }
    
  }
  #form {
   .formSection {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    h5 {
      color: $color2;
      font-weight: 400;
      display: block;
      clear: both;
    }
    .formElement {
      font-size: 0.9rem;
      width: 100%;
      margin: 3px 0;
      padding: 0;
      float: left;
      @include media-md {
        max-width: 50%;
      }
      label {
        width: 100%;
        display: block;
        padding-bottom: 0;
      }
      input,
      textarea {
        border: none;
        border-bottom: 1px solid $lightGrey;
        padding: 0.5rem 0.5rem;
        padding-top: 0;
        width: 90%;
        max-width: 400px;
      }
      textarea {
        height: 110px;
      }
    }
    button {
      width: 90%;
      max-width: 400px;
      border-radius: 0;
      padding: 0.7rem 0.5rem;
      display: block;
      clear: both;
      @include media-md {
        text-align: center;
        margin: 20px auto;
      }
    }
  }
  #address {
    p {
      margin: 3px 0;
      transition: all 0.3s;
      &:hover {
        transform: translateX(3px);
      }
    }
  }
}
</style>
